module.exports = __webpack_public_path__ + "static/media/152.e8307ce4.png";